import { API } from './api';
import { GW_SERVICES_PREFIXES } from '../constants/gateway';

const { REQ } = GW_SERVICES_PREFIXES;

export const GetRequestList = (params: any) =>
  API.get(`/${REQ}/request/tenant/`, params);

export const GetRequest = (requestId: string) =>
  API.get(`/${REQ}/request/tenant/${requestId}/`);

export const CreateRequest = (data: any) =>
  API.post(`/${REQ}/request/tenant/`, data);

export const RateRequest = (requestId: string, rate: number) =>
  API.patch(`/${REQ}/request/tenant/rate/${requestId}/`, {
    score: rate,
  });

/** Резерв id для файла в заявке */
export const ReserveRequestFile = (params: {
  filename: string;
}): Promise<{ shared_id: string; file_id: string }> =>
  API.get(`/${REQ}/files/reserve/`, params);

/** Получение shared_id для скачивания файла с микросервиса файлов. */
export const GetRequestFileSharedId = (params: {
  file_ids: string;
  filenames: string;
}): Promise<{ shared_id: string }> =>
  API.get(`/${REQ}/files/temporary/`, params);

export const GetKindsTree = () => {
  return API.get(`/${REQ}/constants/request/tenant/categories_tree/`); //constants/requests/categories_tree/
};

/* Получение публичной заявки */
export const GetPublicRequest = (id: string) =>
  API.get(`/${REQ}/public/request/${id}/`);

/* Оценка публичной заявки */
export const RatePublicRequest = (id: string, score: number) =>
  API.post(`/${REQ}/public/request/${id}/rate`, {
    score,
  });

/* Получение файлов у публичной заявки */
export const GetPublicRequestAttachments = (id: string) =>
  API.get(`/${REQ}/public/request/${id}/files`);

/* Резервация файлов */
export const ReserveAttachments = (filenames: string[]) =>
  API.post(`/${REQ}/files/reserve/many`, filenames);

/* Прикрепление файла к заявке */
export const AttachFiles = (
  id: string,
  files: { file_id: string; filename: string }[]
) => API.post(`/${REQ}/public/request/${id}/files/attach`, files);

/* Получение начислений для публичной заявки */
export const GetPublicRequestAccruals = (id: string) =>
  API.get(`/${REQ}/public/accruals/${id}`);

/* Получение ссылки на оплату по направлению */
export const CreatePaymentLink = (id: string, sector_code: string) =>
  API.post(`/${REQ}/public/accruals/${id}/pay-link`, { sector_code });

/* Получение счётчиков для публичной заявки */
export const GetPublicRequestMeters = (id: string) =>
  API.get(`/${REQ}/public/meters/${id}/`);

/* Создание заявки на поверку на странице публичной заявки */
export const CreateMetersCheckRequest = (
  id: string,
  data: { meter_id: string }[]
) => API.post(`/${REQ}/public/meters/${id}/request`, data);

/* Передача показаний счётчиков на странице публичной заявки */
export const PostMetersReadings = (
  request_id: string,
  data: { meter_id: string; values: number[] }[]
) => API.post(`/${REQ}/public/meters/${request_id}/readings`, data);
